/* eslint-disable react/no-danger */
// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {get} from 'lodash';

// Relative Imports
import actions from '../../actions/actions';
import SubHead from '../SubHead/SubHead';
import ButtonHolder from '../ButtonHolder/ContinueButtonHolder';
import './styles.less';
import helpActions from '../../actions/help';
import userInfoActions from '../../actions/userInfo';
import hasPpsListingsActions from '../../actions/hasPpsListings';
import InfoCard from '../Card/InfoCard';
import { isEMEABrandSite, isNetNewIPM, isUsSite} from '../../utils/validate';
import { processTranslation, renderLinkedTranslation } from "../utils/commonUtil";
import {MERCHANT_OF_RECORD, getHostCancellationPolicyUrl} from '../../utils/constants';

function mapStateToProps(state) {
    return {
        translations: state.app.translations,
        publicUuid: get(state, 'app.publicUuid', '-1'),
        accountUuid: get(state, 'app.accountUuid', ''),
        siteName: state.system.siteName,
        brandName: state.system.brandName,
        locale: state.system.locale,
        userInfo: get(state, 'userInfoDetails.userInfoMetadata', ''),
        hasPpsListings: get(state, 'hasPpsListings.hasPpsListings', false),
        isSaveModalOpen: get(state, 'app.isSaveModalOpen', false),
        userType: get(state, 'app.userType', ''),
        advertiserBusinessModel: get(state, 'userInfoDetails.userInfoMetadata.businessModel', null),
        dyff: get(state, 'app.dyff', {}),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
        userInfoActions: bindActionCreators(userInfoActions, dispatch),
        hasPpsListingsActions: bindActionCreators(hasPpsListingsActions, dispatch),
        helpActions: bindActionCreators(helpActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class ListingModel extends React.Component {
    constructor(props) {
        super(props);
        this.handleContinueClick = this.handleContinueClick.bind(this);
        this.handleSaveAndFinishOnClick = this.handleSaveAndFinishOnClick.bind(this);
        this.handleSaveModalClose = this.handleSaveModalClose.bind(this);
    }

    componentDidMount() {
        if (!this.props.userInfo) {
            this.props.actions.enableLoadOverLay(true);
            this.props.userInfoActions.getUserInfo();
        } else {
            this.props.actions.enableLoadOverLay(false);
        }

        this.props.hasPpsListingsActions.getHasPpsListings();

        this.props.actions.triggerEdapPageView(this.props.publicUuid, 'Listing Model Page');
    }

    handleContinueClick() {
        this.props.actions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue'
        }, {});
        this.props.actions.changeAppState('PURCHASE_ORDER');
    }

    handleSaveAndFinishOnClick() {
        this.props.actions.showSaveAndFinishModal(true);
    }

    handleSaveModalClose() {
        this.props.actions.showSaveAndFinishModal(false);
    }

    getListingModelContent() {
        const {
            translations,
            brandName
        } = this.props;

        return (<div className="listingmodel-content-col">
            <h2 className="listingmodel-heading">
                {translations['ipmob.listingmodel.heading']}
            </h2>
            <div className="listingmodel-desc">
                <p> {translations['ipmob.listingmodel.sub.heading']} </p>
                <div className="listingmodel-desc-sub" dangerouslySetInnerHTML={{__html: translations['ipmob.listingmodel.content_1']}}/>
                <p> {translations['ipmob.listingmodel.content_2'].replace(/\[brand\]/gi, brandName)} </p>
                <p> {translations['ipmob.listingmodel.content_3'].replace(/\[brand\]/gi, brandName)} </p>
            </div>
        </div>);
    }

    getMoRListingModelContent() {
        const { translations } = this.props;

        return (<div className="listingmodel-content-col">
            <h2 className="listingmodel-heading">
                {translations['ipmob.listingmodel.mor_heading']}
            </h2>
            <div className="listingmodel-desc">
                <h3>{translations['ipmob.listingmodel.sub.mor_heading_1']}</h3>
                <ul>
                    <li>{translations['ipmob.listingmodel.mor_ppb_content_1']}</li>
                    <li>{translations['ipmob.listingmodel.mor_ppb_content_2']}</li>
                    <li>{translations['ipmob.listingmodel.mor_commission_content_1']}</li>
                </ul>
            </div>
        </div>);
    }

    getCommercialListingModelContent(userType) {
        const {
            translations,
            brandName,
        } = this.props;

        return (<div className="listingmodel-content-col">
            <h2 className="listingmodel-heading">
                {translations['ipmob.commercial.listingmodel.heading']}
            </h2>
            <div className="listingmodel-desc">
                {
                    (!isNetNewIPM(userType))
                        ? <p> {translations['ipmob.ppm.listingmodel.content_7']} </p>
                        : null
                }
                <p> {translations['ipmob.commercial.listingmodel.sub.heading']} </p>
                <div className="listingmodel-desc-sub" dangerouslySetInnerHTML={{ __html: translations['ipmob.commercial.listingmodel.content_1'].replace(/\[brand\]/gi, brandName) }} />
            </div>
        </div>);
    }

    getMoRCommercialListingModelContent(userType, siteName, locale) {
        const {
            translations,
            brandName,
        } = this.props;

        const isEMEA = isEMEABrandSite(siteName);
        const hostCancellationsContent = translations['ipmob.listingmodel.host.cancellations.content_1'];

        return (<div className="listingmodel-content-col">
            <h2 className="listingmodel-heading">
                {translations['ipmob.listingmodel.mor_heading']}
            </h2>
            <div className="listingmodel-desc">
                <h3>{translations['ipmob.commercial.listingmodel.sub.mor_heading_1']}</h3>
                <ul>
                    <li>{translations['ipmob.listingmodel.mor_ppb_content_1']}</li>
                    <li>{translations['ipmob.listingmodel.mor_ppb_content_2']}</li>
                    <li>{processTranslation(translations['ipmob.commercial.listingmodel.mor_ppb_content_3'], [brandName])}</li>
                </ul>
                <h3> {translations['ipmob.commercial.listingmodel.sub.mor_heading_2']} </h3>
                <ul>
                    <li>{translations['ipmob.commercial.listingmodel.mor_commission_content_1']}</li>
                    <li>{translations['ipmob.commercial.listingmodel.mor_commission_content_2']}</li>
                    {!isEMEA && <li>{translations['ipmob.commercial.listingmodel.mor_commission_content_3']}</li>}
                    <li>{processTranslation(translations['ipmob.commercial.listingmodel.mor_commission_content_4'], [brandName])}</li>
                    {hostCancellationsContent &&
                        <li>{renderLinkedTranslation(hostCancellationsContent, getHostCancellationPolicyUrl(locale))}</li>}
                </ul>
            </div>
        </div>);
    }

    getPpsListingsInfoCard() {
        const { translations } = this.props;

        return (
            <div className="listingmodel-content-col listingmodel-info-card-col">
                <InfoCard className="listingmodel-info-card">
                    <h2 className="info-card-header">{translations['ipmob.mor.listing.model.info.heading']}</h2>
                    <p className="info-card-text">{translations['ipmob.mor.listing.model.info.content_1']}</p>
                    <p className="info-card-text">{translations['ipmob.mor.listing.model.info.content_2']}</p>
                </InfoCard>
            </div>
        );
    }

    render() {
        const {
            translations,
            isSaveModalOpen,
            userType,
            siteName,
            locale,
            advertiserBusinessModel,
            hasPpsListings
        } = this.props;

        let ipmBankingEnabled = this.props.dyff?.SHARED_IPM_BANKING_ENABLED && advertiserBusinessModel === MERCHANT_OF_RECORD.EG || false;

        let listingModelInnerComponent;
        if (ipmBankingEnabled) {
            listingModelInnerComponent = isUsSite(siteName)
                ? this.getMoRListingModelContent()
                : this.getMoRCommercialListingModelContent(userType, siteName, locale);
        } else {
            listingModelInnerComponent = isUsSite(siteName)
                ? this.getListingModelContent()
                : this.getCommercialListingModelContent(userType);
        }

        return (
            <div id="listingmodel" className="listingmodel">
                <div className="listingmodel-container">
                    <SubHead
                        translations={translations}
                        handleSaveAndFinishOnClick={this.handleSaveAndFinishOnClick}
                        isSaveModalOpen={isSaveModalOpen}
                        handleSaveModalClose={this.handleSaveModalClose}
                    />
                    <div className="listingmodel-wrapper">
                        {listingModelInnerComponent}
                        {ipmBankingEnabled && hasPpsListings && this.getPpsListingsInfoCard()}
                    </div>
                    <ButtonHolder translations={translations} enableContinueButton handleContinueButtonClick={this.handleContinueClick}/>
                </div>
            </div>
        );
    }
}
